import { z } from 'zod';
export const relationshipsCustomerPortalIntakeAcceptanceCapability = 'relationships.customer-portal-intake-acceptance.v1';
export const relationshipsCustomerPortalIntakeAcceptanceSlot = 'customer-portal.project-intake-acceptance-actions';
export const relationshipsCustomerPortalIntakeAcceptanceProviderId = 'relationships.server.customer-portal-intake-acceptance';
const nullableText = (maximum) => z.string().trim().min(1).max(maximum).nullable();
export const relationshipsCustomerPortalIntakeAcceptanceRequestSchema = z.strictObject({
    consumerModuleId: z.literal('customer-portal'),
    requestedCapability: z.literal(relationshipsCustomerPortalIntakeAcceptanceCapability),
    sourceCapability: z.literal('customer-portal.project-intake-requests.v1'),
    commandId: z.string().uuid(),
    projectId: z.string().uuid(),
    intakeRequestId: z.string().uuid(),
    submissionId: z.string().uuid(),
    submissionRevision: z.number().int().positive(),
    submissionHash: z.string().regex(/^[a-f0-9]{64}$/),
    customer: z.strictObject({
        customerName: nullableText(200),
        customerEmail: z.string().trim().email().max(320).nullable(),
        customerPhone: nullableText(50),
        communicationPreferences: z.strictObject({
            email: z.boolean(),
            sms: z.boolean(),
            phone: z.boolean(),
            preferredChannel: z.enum(['email', 'sms', 'phone']).nullable(),
        }),
    }),
});
export const relationshipsCustomerPortalIntakeAcceptanceResponseSchema = z.strictObject({
    state: z.literal('accepted'),
    capability: z.literal(relationshipsCustomerPortalIntakeAcceptanceCapability),
    tenantId: z.string().uuid(),
    projectId: z.string().uuid(),
    intakeRequestId: z.string().uuid(),
    factId: z.string().uuid(),
    idempotent: z.boolean(),
});
//# sourceMappingURL=relationships-customer-portal-intake.contract.js.map